import BeautyProfileHeadingTitle from 'components/Header/BeautyPreferences/BeautyProfileHeading/BeautyProfileHeadingTitle/BeautyProfileHeadingTitle';

export default BeautyProfileHeadingTitle;
